import React, { ReactNode, useEffect, useState } from "react";
import styles from "./PlaydateInviteBaseUnit.module.css";
import { PlaydateInvite } from "../../gql/types";
import PlaydateInviteLetterhead from "./PlaydateInviteLetterhead";
import UnderlineButton from "../button/UnderlineButton";
import PlaydateInviteDetailsCard from "./PlaydateInviteDetailsCard";
import { showToast } from "../../toast/toast";
import PlaydateInviteOrganizerReviewWorkflow from "./workflow/PlaydateInviteOrganizerReviewWorkflow";
import { useToastContext } from "contexts/ToastContext";

interface PlaydateInvitationCardProps {
    invite: PlaydateInvite;
    headerElement?: ReactNode;
    bottomElement?: ReactNode;
    disableBottomDetails?: boolean;
    onBack: () => void;
    baseZIndex?: number;
}

const PlaydateInvitationCard: React.FC<PlaydateInvitationCardProps> = ({
    invite,
    headerElement,
    bottomElement,
    disableBottomDetails,
    onBack,
    baseZIndex,
}) => {
    const [showDetailsView, setShowDetailsView] = useState(false);
    const { triggerToastEvent } = useToastContext();

    return (
        <>
            <div className={styles.invitationCard}>
                <PlaydateInviteLetterhead
                    logo={headerElement}
                />
                <div className={styles.invitationCardContent}>
                    <PlaydateInviteDetailsCard invite={invite} />
                    {bottomElement && (bottomElement)}
                    {!disableBottomDetails && !bottomElement && <UnderlineButton
                        onClick={() => setShowDetailsView(true)}
                        className={styles.invitationCardDetailsButton}
                    >View Details</UnderlineButton>}
                </div>
            </div >

            {showDetailsView && <PlaydateInviteOrganizerReviewWorkflow
                invite={invite}
                onBack={onBack}
                onDataChange={(success: boolean, invite?: PlaydateInvite) => {
                    if (success) {
                        triggerToastEvent();
                    }
                    onBack();
                }}
                baseZIndex={baseZIndex}
            />}
        </>
    );
};

export default PlaydateInvitationCard;
